<template>
  <MaterialCard
    color="green"
    full-width
  >
    <v-flex>
      {{ authority.name }}
    </v-flex>
    <v-flex>
      {{ authority.description }}
    </v-flex>
  </MaterialCard>
</template>
<script>
export default {
  // eslint-disable-next-line
  props: {
    authority: {
      type: Object,
      default: () => null
    }
  },
  data: () => ({
  })
}
</script>
